"use client";

import { TooltipProvider } from "@/components/ui/tooltip";
import { TRPCReactProvider } from "@/trpc/react";
import { ThemeProvider } from "./theme-provider";

// ClerkProvider / ConvexClientProvider / SentryUserScope used to live
// here too, but that meant every marketing pageview (and the 404)
// booted Clerk and opened a Convex WebSocket for a header button
// label nobody there needed live auth for (#1257). They now live in
// AuthProviders, mounted only by dashboard/layout.tsx, (auth)/layout.tsx,
// admin/layout.tsx and control/[orgId]/layout.tsx.
//
// TRPCReactProvider stays global: the marketing tree's own public
// leads form (lead-capture-form.tsx) uses the tRPC client too, and
// mounting this provider doesn't cost a network request by itself —
// it only constructs a QueryClient + tRPC client; nothing fetches
// until a query/mutation actually runs.
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      disableTransitionOnChange
    >
      <TRPCReactProvider>
        <TooltipProvider>{children}</TooltipProvider>
      </TRPCReactProvider>
    </ThemeProvider>
  );
}
